"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SortButtonDirection;

(function (SortButtonDirection) {
  SortButtonDirection["unset"] = "unset";
  SortButtonDirection["ascending"] = "ascending";
  SortButtonDirection["descending"] = "descending";
})(SortButtonDirection = exports.SortButtonDirection || (exports.SortButtonDirection = {}));